<template>
<div>
    <div v-if="isShow">
        <header>自己紹介分のポイント<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
        </header>
        <div id="wrap">
            <img v-if="parseInt(sex) === FEMALE" src="~@/assets/images/self-f.png" style="width: 100%;" />
            <img v-else src="~@/assets/images/self-m.png" style="width: 100%;" />
            <div class="self-txt">以下のような内容をプロフィールに記載することは禁止されています。記載された場合、審査の際に否認させていただきますので、ご了承ください。
                <div class="self-area">
                    <table>
                        <tr>
                            <td class="self1"><i class="fas fa-times-circle"></i></td>
                            <td class="self2">電話番号、メールアドレス、住所、URLなどの連絡先情報</td>
                        </tr>
                        <tr>
                            <td class="self1"><i class="fas fa-times-circle"></i></td>
                            <td class="self2">他サービスのアカウント情報、またそれを想起ささえる表現</td>
                        </tr>
                        <tr>
                            <td class="self1"><i class="fas fa-times-circle"></i></td>
                            <td class="self2">関係者を不快にさせる表現</td>
                        </tr>
                        <tr>
                            <td class="self1"><i class="fas fa-times-circle"></i></td>
                            <td class="self2">あなたの本名</td>
                        </tr>
                        <tr>
                            <td class="self1"><i class="fas fa-times-circle"></i></td>
                            <td class="self2">勤務先企業名など所属する組織を特定させるもの</td>
                        </tr>
                        <tr>
                            <td class="self1"><i class="fas fa-times-circle"></i></td>
                            <td class="self2">その他GreedGreedの利用規約に反する内容など</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import CONSTANTS from '@/constants'
export default {
    props: {
        isShow: Boolean,
        sex: String,
    },
    data: () => ({
        FEMALE: CONSTANTS.FEMALE,
    }),
    emits: ['close'],
}
</script>
